<mat-slide-toggle
    [(ngModel)]="showMemoColumn"
    [labelPosition]="'before'"
    class="mr-5 mt-3"
    matTooltip="Toggle showing memo column">
    Show memo column?
</mat-slide-toggle>
